export default __webpack_public_path__ + "static/media/cert-of-education-1.35dca554.svg";